import { createSlice } from '@reduxjs/toolkit';
import { getPeriodList, updatePeriod } from './thunk';

export const initialState = {
	periodList: [],
	isLoading: false,
	isSuccess: false,
	isError: false,
	error: null,
};

const periodSlice = createSlice({
	name: 'Period',
	initialState,
	reducers: {},
	extraReducers: builder => {
		// getPeriodList
		builder.addCase(getPeriodList.pending, state => {
			state.isLoading = true;
			state.periodList = []; // Reset list on new request
		});
		builder.addCase(getPeriodList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.periodList = action.payload;
		});
		builder.addCase(getPeriodList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.error.message;
		});
		// updatePeriod
		builder.addCase(updatePeriod.pending, state => {
			state.isLoading = true;
		});
		builder.addCase(updatePeriod.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.periodList = state.periodList.map(item =>
				item._id === action.payload._id
					? { ...item, ...action.payload }
					: item
			);
		});
		builder.addCase(updatePeriod.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.error.message;
		});
	},
});

export default periodSlice.reducer;
